document.addEventListener("rebuy.ready", function () {
  const rebuyWidgets = document.querySelectorAll('.widget-type-product .rebuy-widget-content');

  if (rebuyWidgets.length > 0) {
    rebuyWidgets.forEach((widget) => {
      if (!(widget.querySelector('.widget-top-container'))) {
        const rebuyProductBlocks = widget.querySelectorAll('.rebuy-product-block');
        const widgetDescription = widget.querySelector('.description');
        const widgetVisibilityElement = widget.closest('.widget-type-product');
        const widgetTitle = widget.querySelector('.primary-title');
        const parentSection = widget.closest('.section');

        const widgetTopContainer = document.createElement('div');
        const widgetButtonContainer = document.createElement('div');

        widgetTopContainer.className = 'widget-top-container';
        widgetButtonContainer.className = 'widget-button-container';
        widget.insertBefore(widgetTopContainer, widget.firstChild);
        widgetTopContainer.appendChild(widgetTitle);
        widgetTopContainer.appendChild(widgetButtonContainer);

        if (widgetVisibilityElement && widgetVisibilityElement.classList.contains('is-hidden')) {
          parentSection.style.paddingTop = '0';
        }

        if (widgetDescription) {
          widgetTopContainer.appendChild(widgetDescription);
        }

        if (rebuyProductBlocks.length < 5) {
          if (widgetDescription) {
            widgetDescription.style.display = 'block';
          }
        } else {
          if (widgetDescription) {
            widgetDescription.remove();
          }
        }

        rebuyProductBlocks.forEach((block, index) => {
          const badgeList = block.querySelector(".product-card__badge-list");
          if (badgeList) {
            return;
          }

          let productName = '';
          const blockProductInfo = block.querySelector('.rebuy-product-info a');
          if (blockProductInfo) {
            productName = blockProductInfo.textContent.trim();
          }

          let productId = '';
          const productIdClass = Array.from(block.classList).find(className => className.startsWith('product-id-'));
          if (productIdClass) {
            productId = productIdClass.split('-').pop();
          }

          const compareAtPrice = block.querySelector(".compare-at");
          if (compareAtPrice) {
            const badgeListDiv = document.createElement('div');
            badgeListDiv.className = 'product-card__badge-list';

            const badge = document.createElement('span');
            badge.className = 'badge badge--on-sale';
            badge.textContent = 'On Sale';

            badgeListDiv.appendChild(badge);
            block.appendChild(badgeListDiv);
          }

          block.addEventListener("click", function (event) {
            Shopify.analytics.publish('Recommendation Click', {
              "widgetTitle": widgetTitle?.textContent?.trim(),
              "widgetId": widget?.closest('[data-rebuy-id]')?.getAttribute('data-rebuy-id'),
              "productName": productName,
              "productId": productId,
              "productPosition": index + 1,
              "path": window.location.pathname
            });
          });
        });
      }

      // Monitoring for Flickity buttons since they can be loaded asynchronously
      const observer = new MutationObserver(() => {
        const widgetNextButton = widget.querySelector('.flickity-button.next');
        const widgetPreviousButton = widget.querySelector('.flickity-button.previous');
        const widgetButtonContainer = widget.querySelector('.widget-button-container');

        if (widgetNextButton && widgetPreviousButton && widgetButtonContainer) {
          widgetButtonContainer.appendChild(widgetPreviousButton);
          widgetButtonContainer.appendChild(widgetNextButton);
          observer.disconnect(); // Stop observing once buttons are found and moved
        }
      });

      observer.observe(widget, { childList: true, subtree: true });
    });
  }
});
